// extracted by mini-css-extract-plugin
export var cardHeader = "_ek-0";
export var reorderHandle = "_ek-3";
export var titleArea = "_ek-1";
export var titleAreaWithHandle = "_ek-2";